import { GRAY_300, GRAY_950, WHITE } from '../scss/colorConsts'

/**
 * Takes in a care team list, and provides a transformed options list
 */
export function generateCareTeamByFacilityOptions(
  careTeamList,
  visitFacilityId,
  currentCareTeamValue,
) {
  let options = careTeamList
    ?.filter((careTeam) => careTeam?.facility_id === visitFacilityId)
    ?.map((careTeam) => {
      return { label: careTeam.careteam, value: careTeam.careteam }
    })

  options.push({
    label: currentCareTeamValue ? 'Remove' : '-',
    value: '',
  })
  return options
}

export const selectStyleDark = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'var(--reactselect-input-bg-color)',
    color: 'var(--reactselect-input-color)',
  }),
  input: (styles) => ({ ...styles, color: 'var(--reactselect-input-color)' }),
  menu: (styles) => ({ ...styles, backgroundColor: 'var(--reactselect-input-bg-color)' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? 'var(--text-glow-color)'
          : isFocused
            ? 'var(--text-glow-color)'
            : 'var(--react-select-side-panel-bg)',
      color: isDisabled ? GRAY_300 : isSelected ? GRAY_950 : isFocused ? GRAY_950 : data?.color,
      whiteSpace: 'break-spaces',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      borderBottom: `1px solid ${GRAY_300}`,
      'last-child': {
        border: 'none',
      },
      ':active': {
        ...styles[':active'],
        backgroundColor: 'var(--text-glow-color)',
      },
    }
  },
  placeholder: (styles) => ({ ...styles, color: 'var(--reactselect-placeholder-color)' }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: 'var(--reactselect-input-color)',
    whiteSpace: 'break-spaces',
  }),
}

export const selectStyleLight = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'var(--reactselect-input-bg-color)',
    color: 'var(--reactselect-input-color)',
  }),
  input: (styles) => ({
    ...styles,
    color: 'var(--reactselect-input-color)',
  }),
  menu: (styles) => ({ ...styles, backgroundColor: 'var(--reactselect-input-bg-color)' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? 'var(--text-glow-color)'
          : isFocused
            ? 'var(--text-glow-color)'
            : WHITE,
      color: isDisabled ? GRAY_300 : GRAY_950,
      whiteSpace: 'break-spaces',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      borderBottom: `1px solid ${GRAY_300}`,
      'last-child': {
        border: 'none',
      },
      ':active': {
        ...styles[':active'],
        backgroundColor: 'var(--text-glow-color)',
      },
    }
  },
  placeholder: (styles) => ({ ...styles, color: 'var(--reactselect-placeholder-color)' }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: 'var(--reactselect-input-color)',
    whiteSpace: 'break-spaces',
  }),
}
